/* unplugin-vue-components disabled */import { render } from "./orderRemark.vue?vue&type=template&id=e45ee262&scoped=true"
import script from "./orderRemark.vue?vue&type=script&lang=js"
export * from "./orderRemark.vue?vue&type=script&lang=js"

import "./orderRemark.vue?vue&type=style&index=0&id=e45ee262&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e45ee262"]])

export default __exports__